import RegistrationBg from '../../../../../../public/img/registration-group/reg-bg.svg?inline'

export default {
  name: "Banner",

  components: {
    RegistrationBg
  }
}
